import React from "react";
import type {VoidFunctionComponent} from "react";
import {useDemoModeSelectorIconLogic} from "./DemoModeSelectorIcon.logic";
import {FontIcon} from "../../../components/common/FontIcon";
import {useIsDeviceDesktop} from "../../../services/device/device-info-hooks";

export const DemoModeSelectorIcon: VoidFunctionComponent = () => {
  const {handIcons} = useDemoModeSelectorIconLogic();
  const isDesktop = useIsDeviceDesktop();

  return (
    <div className="demo-hands-button">
      <FontIcon icon={handIcons.left} additionalClassName={handIcons.isLeftHandSoundOrHighlightEnabled ? '' : 'inactive'} />
      <FontIcon icon={handIcons.right} additionalClassName={handIcons.isRightHandSoundOrHighlightEnabled ? '' : 'inactive'} />
      {isDesktop ? <FontIcon icon={"icon-angle-down"}/> : null }
    </div>
  );
}
